// removed by extract-text-webpack-plugin
module.exports = {"mask":"fVOw8PGTFXn3vA0cHssiR"};